// skio:filter:start
// Only the active subscription platform's selling plan allocations (Theme settings > Subscriptions, via window.subscriptionAppId).
function skioAllocs(variant, prod) {
    const ids = ((prod && prod.selling_plan_groups) || [])
        .filter(g => String(g.app_id) === String(window.subscriptionAppId))
        .map(g => g.id);
    return ((variant && variant.selling_plan_allocations) || [])
        .filter(a => ids.includes(a.selling_plan_group_id));
}
// skio:filter:end

(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`[data-section="${sectionID}"]`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productV26JSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productV26VariantJSON").textContent);

    // map of variant id to its maltertech.ongoing_price metafield (dollars, null when unset)
    const variantIDtoOngoingPrice = JSON.parse(section.querySelector(".productV26VariantIDtoOngoingPriceJSON").textContent);

    // map of variant id to its custom.dosage_with_text metafield, the same per dose copy the selling card shows
    const variantIDtoDose = JSON.parse(section.querySelector(".productV26VariantIDtoDoseJSON").textContent);

    // map of variant id to its maltertech.one_time_purchase_swap variant id (null when unset)
    const variantSwapMap = JSON.parse(section.querySelector(".productV26VariantSwapJSON").textContent);


    /************
     Product Swiper
     ************/

    let thumbs = new Swiper(section.querySelector(".productV26VisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 4
    });


// setup product swiper
    const productV26Swiper = new Swiper(section.querySelector(".productV26VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: true,
        navigation: {
            nextEl: section.querySelector('.productV26VisualSwiperNext'),
            prevEl: section.querySelector('.productV26VisualSwiperPrev'),
        },
        thumbs: {
            swiper: thumbs
        },
        on: {
            slideChange: function () {
                // pause all videos
                section.querySelectorAll(".productV26VisualSwiperSlide video")?.forEach(element => {
                    element.pause();
                });
            }
        }
    });


// play video on slide play click
    section.querySelectorAll(".productV26VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV26VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV26VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

// setup Dropdowns
    section.querySelectorAll(".productV26InfoDropdownTop")?.forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    /**************
     Product Variants
     ***************/

// update active variant on input changes
    section.querySelectorAll("input").forEach(function (element) {
        element.addEventListener("change", function () {

            updateProduct();

        });
    })

// update active variant
    function updateProduct() {
        let sellingPlanExists = section.querySelector(".productV26Selling") || false;


        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV26OptionItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }


        section.querySelector(".productV26ATC").classList.remove('bulk');


        // check if variant wasn't found (and not bulk)
        if ((activeVariant === null || activeVariant === undefined)) {
            section.querySelector(".productV26ATC").disabled = true;
            section.querySelector(".productV26ATC").textContent = "not available";
            return;
        }

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV26ATC").disabled = false;
            section.querySelector(".productV26ATC").textContent = section.querySelector(".productV26ATC").dataset.label || "add to cart";
        } else {
            section.querySelector(".productV26ATC").disabled = true;
            section.querySelector(".productV26ATC").textContent = "sold out";
        }

        // update selling plan
        updateSellingPlan(sellingPlanExists, activeVariant)

        // update payments form data
        const payInstallmentsInput = section.querySelector('.productV26PaymentsInput');
        const shopifyPaymentTerms = section.querySelector('shopify-payment-terms');
        if (payInstallmentsInput) {
            payInstallmentsInput.value = activeVariant.id;
        }
        if (shopifyPaymentTerms) {
            shopifyPaymentTerms.dataset.variantId = activeVariant.id;
            shopifyPaymentTerms.setAttribute('variant-id', activeVariant.id);
        }
        section.dispatchEvent(new CustomEvent('mainProduct:update'))
    }

    /**************
     Product Selling Plan
     ***************/

    function updateSellingPlan(sellingPlanExists = true, activeVariant) {
        // Selling Plan element doesn't exist
        if (!sellingPlanExists) {
            return;
        }

        // skio:filter:start
        // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
        let activeVariantPlan = skioAllocs(activeVariant, product)[0];
        // skio:filter:end

        // reset selcet
        let optionsHTML = "";
        // loop over every selling plan allocation for this active variant

        // skio:filter:start
        // was: activeVariant.selling_plan_allocations.forEach(sellingPlanAllocation => {
        skioAllocs(activeVariant, product).forEach(sellingPlanAllocation => {
        // skio:filter:end
            // find the selling plan name since it's not in the object
            let sellingPlan = getSellingPlanById(sellingPlanAllocation.selling_plan_id);

            // create an option for the select
            // manual check for the starter kit selling plan
            if (sellingPlanAllocation.selling_plan_group_id !== "91e7beddcc2b25a88da97e3b201deec8db7b43bb") {
                optionsHTML += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
            }
        });
        section.querySelectorAll(".productV26SellingLabelBodyBottomWrapContentSelect").forEach((select) => {
            select.innerHTML = optionsHTML;
        })

        // update text
        let save = (1 - (activeVariantPlan.price / activeVariant.price)) * 100;

        // save parent elements
        const once = section.querySelector(".productV26SellingLabelBody.once");
        const sub = section.querySelector(".productV26SellingLabelBody.sub");

        // update compare at price for one time and sub
        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV26SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        } else {
            once.querySelector(".productV26SellingLabelBodyPriceCompare").textContent = "";
        }

        sub.querySelector(".productV26SellingLabelBodyPriceCompare").textContent = price(activeVariant.compare_at_price * quantity, true);
        if (activeVariantPlan.compare_at_price > activeVariant.compare_at_price) {
            sub.querySelector(".productV26SellingLabelBodyPriceCompare").textContent = price(activeVariantPlan.compare_at_price * quantity, true);
        }

        // update actual price
        once.querySelector(".productV26SellingLabelBodyPriceReal").textContent = price(activeVariant.price * quantity, true);
        sub.querySelector(".productV26SellingLabelBodyPriceReal").textContent = price(activeVariantPlan.price * quantity, true);

        once.querySelector(".productV26SellingLabelBodyPriceReal").classList.remove("sale");

        if (activeVariant.compare_at_price > activeVariant.price) {
            once.querySelector(".productV26SellingLabelBodyPriceReal").classList.add("sale");
        }

        // update save text
        // if one time, save $15, else save $30
        if (section.querySelector('.productV26SellingLabelInput:checked').value === "sub") {
            section.querySelector('.productV26OptionItemValuesLabelBodyWrapSave.active').textContent = `Save $46`;
        } else {
            section.querySelector('.productV26OptionItemValuesLabelBodyWrapSave.active').textContent = `Save $15`;
        }

        // update one time bullets
        if (section.querySelector('.productV26OptionItemValuesLabelInput:checked').value === "4" && section.querySelector('.productV26SellingLabelInput:checked').value === "once") {
            once.querySelector(".productV26SellingLabelBodyBottomWrapContentBullets.once")?.classList.add("active");
        }

        section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
            element.classList.remove("active");
        });
        if (section.querySelector('.productV26SellingLabelInput:checked').value === "sub") {
            section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.subOnly')?.forEach((element) => {
                element.classList.add("active");
            });
        }

        // update 4 tins icons
        if (section.querySelector('.productV26OptionItemValuesLabelInput:checked').value === "4") {
            section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        // update 2 tins icons
        if (section.querySelector('.productV26OptionItemValuesLabelInput:checked').value === "2") {
            section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.twoTinsOnly').forEach((element) => {
                element.classList.add("active");
            });

            section.querySelectorAll('.productV26SellingLabelBodyBottomWrapContentBulletsItem.fourTinsOnly').forEach((element) => {
                element.classList.remove("active");
            });
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }


    /****************
     * Product Quantity
     */

    let quantity = 1;
    updateProduct();


    /**************
     Product ATC
     ***************/

    section.querySelector(".productV26ATC").addEventListener("click", async function () {


        // add loading animation
        this.classList.add("loading");

        // if subscription keep the same product, if OTP use the OTP version of the active variant
        let activeVariantID = activeVariant.id;
        if (section.querySelector('.productV26SellingLabelInput:checked').value === "once") {
            // if OTP, switch to OTP variant
            if (variantSwapMap[activeVariantID]) {
                activeVariantID = variantSwapMap[activeVariantID];
            } else if (activeVariantID === 44847060418697) {
                activeVariantID = 44847055700105;
            } else {
                activeVariantID = 44847055732873;
            }
        }

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariantID,
            }]
        };

        // check for selling plan
        if (section.querySelector('.productV26SellingLabelInput.sub')?.checked) {
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: let activeVariantPlan = activeVariant.selling_plan_allocations[0];
            let activeVariantPlan = skioAllocs(activeVariant, product)[0];
            // skio:filter:end
            // find the correct selling_plan_allocation
            // skio:filter:start
            // was: for (let plan of activeVariant.selling_plan_allocations) {
            for (let plan of skioAllocs(activeVariant, product)) {
            // skio:filter:end
                if (plan.selling_plan_id === parseInt(section.querySelector('.productV26SellingLabelBodyBottomWrapContentSelect').value)) {
                    activeVariantPlan = plan;
                }
            }
            formData.items[0].selling_plan = activeVariantPlan.selling_plan_id
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();
    });


    /**
     * Given a selling plan id, find the master selling plan object
     * @param {number} sellingPlanId
     * @returns {Object}
     */
    function getSellingPlanById(sellingPlanId) {
        let sellingPlan = null;
        product.selling_plan_groups.forEach(group => {
            group.selling_plans.forEach(plan => {
                if (plan.id === sellingPlanId) {
                    sellingPlan = plan;
                }
            });
        });
        return sellingPlan;
    }


    // font fix override for shopify payments (make b element normal weight)
    document.addEventListener("DOMContentLoaded", async function () {
        customElements.whenDefined("shopify-payment-terms").then(() => {
            customElements.whenDefined("shop-pay-installments-banner").then(() => {
                // the element is absent on products without installments, so bail out rather than throw
                const bannerBold = section.querySelector("shopify-payment-terms")?.shadowRoot?.querySelector("shop-pay-installments-banner")?.shadowRoot?.querySelector("b");
                if (!bannerBold) {
                    return;
                }
                bannerBold.style = "font-weight: 400;";
            });
        });
    });


    /************
     Selling UI (folded from shared product-main.js + product-js.js, section-scoped)
     ************/

    // initialize the custom selling-plan select dropdown
    function initializeCustomSelect() {
        const selectElement = section.querySelector(".productV26SellingLabelBodyBottomWrapContentSelect");
        const detailsElement = section.querySelector(".customDetails");
        if (!selectElement || !detailsElement) {
            return;
        }

        const summaryElement = detailsElement.querySelector(".customDetailsTitle");
        const optionElements = detailsElement.querySelectorAll(".customOption");

        // sync the visible summary to the native select's current value
        const initialOption = selectElement.options[selectElement.selectedIndex];
        const initialValue = initialOption ? initialOption.value : "";
        if (summaryElement) {
            summaryElement.firstElementChild.textContent = initialOption ? initialOption.textContent : "";
        }

        optionElements.forEach((option, index) => {
            const value = selectElement.options[index]?.value || "";
            option.setAttribute("data-value", value);
            option.classList.toggle("selected", value === initialValue);
        });

        // clicking a custom option writes back to the native select
        optionElements.forEach((option) => {
            option.addEventListener("click", () => {
                const value = option.dataset.value;
                const text = option.textContent.trim();
                selectElement.value = value;
                if (summaryElement) {
                    summaryElement.firstElementChild.textContent = text;
                }
                optionElements.forEach((opt) => opt.classList.remove("selected"));
                option.classList.add("selected");
                detailsElement.removeAttribute("open");
            });
        });
    }

    // refresh the SAVE badges from the active variant pricing
    function updateSavingsDisplay() {
        if (!activeVariant) {
            return;
        }
        const subSaveElement = section.querySelector(".productV26SellingTagDiscountSub");
        const oneTimeSaveElement = section.querySelector(".productV26SellingTagDiscountOne");
        if (!subSaveElement) {
            return;
        }
        // skio:filter:start
        // was: const sellingPlanPrice = activeVariant.selling_plan_allocations?.[0]?.price;
        const sellingPlanPrice = skioAllocs(activeVariant, product)?.[0]?.price;
        // skio:filter:end
        if (sellingPlanPrice === undefined) {
            return;
        }
        const subTotal = activeVariant.compare_at_price ? activeVariant.compare_at_price - sellingPlanPrice : activeVariant.price - sellingPlanPrice;
        const oneTimeTotal = activeVariant.compare_at_price - activeVariant.price;
        subSaveElement.innerHTML = `SAVE ${price(subTotal, true)}`;
        if (oneTimeSaveElement) {
            if (oneTimeTotal > 0) {
                oneTimeSaveElement.innerHTML = `SAVE ${price(oneTimeTotal, true)}`;
                oneTimeSaveElement.classList.remove("hidden");
            } else {
                oneTimeSaveElement.classList.add("hidden");
            }
        }

        // discount percentage off the base price (compare-at when present, otherwise regular price)
        const basePrice = activeVariant.compare_at_price || activeVariant.price;
        const discountPercent = Math.round((basePrice - sellingPlanPrice) / basePrice * 100);

        // ongoing price comes from the variant's maltertech.ongoing_price metafield (dollars), fall back to the selling plan price
        let ongoingPrice = sellingPlanPrice;
        const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
        if (ongoingPriceMetafield != null) {
            ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
        }
        const ongoingPercent = Math.round((basePrice - ongoingPrice) / basePrice * 100);

        // update bullet price - ongoing price per month plus the ongoing discount percentage
        const bulletSaveElement = section.querySelector(".productV26SellingLabelBodyBottomWrapContentBulletsItemSave");
        if (bulletSaveElement) {
            bulletSaveElement.innerHTML = `
                <span class="productV26SellingLabelBodyBottomWrapContentBulletsItemSavePrice">${price(ongoingPrice, true)}/mo after first order</span>
                <span class="productV26SellingLabelBodyBottomWrapContentBulletsItemSaveOngoing">(${ongoingPercent}% OFF ongoing)</span>
            `;
        }
    }

    // hide the one-time bottom block when it has no text
    function checkOneTimeTextVisibility() {
        const textElement = section.querySelector(".productV26SellingLabelBodyBottomWrapContentTxt");
        const bottomContentElement = section.querySelector(".productV26SellingLabelBody.once .productV26SellingLabelBodyBottom");
        if (!textElement || !bottomContentElement) {
            return;
        }
        bottomContentElement.classList.toggle("hidden", textElement.textContent.trim() === "");
    }

    // swap dosage text when a dosage option is clicked
    section.querySelectorAll("[data-dosage-click]").forEach((dosageOption) => {
        dosageOption.addEventListener("click", function () {
            const subItem = section.querySelector(".productV26SellingLabelBodyTopLeftDosageText");
            const oneTimeItem = section.querySelector(".productV26SellingLabelBodyTopLeftDosageText.oneTime");
            if (subItem) {
                subItem.innerHTML = dosageOption.getAttribute("data-dosage-sub");
            }
            if (oneTimeItem) {
                oneTimeItem.innerHTML = dosageOption.getAttribute("data-dosage-one-time");
            }
        });
    });

    // re-run the selling UI on load and on every product update
    function refreshSellingUI() {
        initializeCustomSelect();
        updateSavingsDisplay();
        checkOneTimeTextVisibility();
    }

    section.addEventListener("mainProduct:update", refreshSellingUI);
    refreshSellingUI();


    /**************
     Product Sticky Bar (Mobile)
     ***************/

    // the sticky bar renders outside the section element, so match it on this section's id
    const productV26Sticky = document.querySelector(`.productV26Sticky[data-product-sticky="${sectionID}"]`);
    if (productV26Sticky) {
        const productV26ATCEl = section.querySelector(".productV26ATC");
        const productV26StickySubInput = productV26Sticky.querySelector('.productV26StickyTopLeftBodyOptionsLabelInput[value="sub"]');
        const productV26StickyDose = productV26Sticky.querySelector(".productV26StickyBottomDose");
        const productV26StickyPrice = productV26Sticky.querySelector(".productV26StickyBottomPrice");
        const productV26StickyATC = productV26Sticky.querySelector(".productV26StickyTopATC");

        // several product sections can share a page, only the first bar whose section is rendered may show
        function ownsSticky() {
            const owner = [...document.querySelectorAll("[data-product-sticky]")].find(bar => {
                const barSection = document.querySelector(`[data-section="${bar.dataset.productSticky}"], [id="${bar.dataset.productSticky}"]`);
                return barSection && barSection.offsetParent !== null;
            });
            return owner != null && owner.dataset.productSticky === sectionID;
        }

        // show the sticky bar whenever the main ATC isn't in the viewport (above or below)
        function toggleStickyVisibility() {
            const rect = productV26ATCEl.getBoundingClientRect();
            const inView = rect.bottom > 0 && rect.top < window.innerHeight;
            productV26Sticky.classList.toggle("visible", !inView && ownsSticky());
        }

        window.addEventListener("scroll", toggleStickyVisibility, {passive: true});
        toggleStickyVisibility();

        // sync the sticky bar choice into the main selling radio so the rest of the page updates
        productV26Sticky.querySelectorAll(".productV26StickyTopLeftBodyOptionsLabelInput").forEach(input => {
            input.addEventListener("change", function () {
                const mainInput = section.querySelector(`.productV26SellingLabelInput.${this.value}`);
                if (mainInput) {
                    mainInput.checked = true;
                    mainInput.dispatchEvent(new Event("change", {bubbles: true}));
                }
                updateProductSticky();
            });
        });

        // sticky ATC reuses the same add-to-cart flow as the main button
        productV26StickyATC.addEventListener("click", function () {
            productV26ATCEl.click();
        });

        // refresh dose visibility and price text from current variant + selling state
        function updateProductSticky() {
            const subChecked = productV26StickySubInput.checked;

            // dose price comes from the active variant's dosage metafield, hidden when it has no price
            const dosePrice = (variantIDtoDose[activeVariant.id] || "").match(/\$\d+(\.\d+)?/);
            productV26StickyDose.textContent = dosePrice ? `${dosePrice[0]}/dose` : "";

            // dose only shows for subscription
            productV26StickyDose.classList.toggle("active", subChecked && dosePrice != null);

            // price text differs by selling type
            if (subChecked) {
                // skio:filter:start
                // was: const subPrice = price(activeVariant.selling_plan_allocations[0].price * quantity, true);
                const subPrice = price(skioAllocs(activeVariant, product)[0].price * quantity, true);
                // skio:filter:end

                // ongoing price comes from the variant's maltertech.ongoing_price metafield, fall back to the selling plan price
                // skio:filter:start
                // was: let ongoingPrice = activeVariant.selling_plan_allocations[0].price;
                let ongoingPrice = skioAllocs(activeVariant, product)[0].price;
                // skio:filter:end
                const ongoingPriceMetafield = variantIDtoOngoingPrice[activeVariant.id];
                if (ongoingPriceMetafield != null) {
                    ongoingPrice = Math.round(parseFloat(ongoingPriceMetafield));
                }

                productV26StickyPrice.innerHTML = `<strong>${subPrice} </strong>+ FREE shipping* - <em>${price(ongoingPrice, true)}/mo after, cancel anytime</em>`;
            } else {
                const oncePrice = price(activeVariant.price * quantity, true);
                productV26StickyPrice.innerHTML = `<strong>${oncePrice}</strong> + $9.99 shipping*`;
            }
        }

        // re-render whenever the main product update event fires
        section.addEventListener("mainProduct:update", updateProductSticky);
        updateProductSticky();
    }

}());